import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/shad/ui/dialog'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice'
import { selectProgramSettings } from '@/storage/program_settings/programSettingsSlice'
import React from 'react'
import { useSelector } from 'react-redux'
import { Button } from '../Button'
import { useTranslation } from 'react-i18next'

interface Props {
    isDialogOpen: boolean
    setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
    trigger: React.ReactNode
}

function ContactSupportModal(props: Props) {
    const programSettings = useSelector(selectProgramSettings)
    const application = useSelector(selectFamilyApplication)

  const { t: translate } = useTranslation()

    const {
        isDialogOpen,
        setIsDialogOpen,
        trigger
    } = props

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogTrigger className="py-1 w-full hover:text-gray-950">
          {trigger}
        </DialogTrigger>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>{translate('need_help')}</DialogTitle>
            <DialogDescription className="text-gray-600 text-center"></DialogDescription>
          </DialogHeader>
          <div className="p-4 text-gray-800">
            <div className="mt-2 mb-4">
              {translate('need_help_info.need_assistance')}{' '}
              {programSettings.name} {translate('need_help_info.by_phone')}
              <div className="font-medium">+1 (985) 800-3950</div>
            </div>
            <div className="mt-2 mb-4">
              {translate('need_help_info.or_email')}
              <div className="font-medium">
                support@acescholarships.org
              </div>
            </div>

            <div className="mt-2 mb-4">
              {translate('need_help_info.provide_id')}
              <div className="font-medium">
                {application.applicant_id}
              </div>
            </div>
            <Button onClick={() => {
                 setIsDialogOpen(false)
            }}>{translate('need_help_info.go_it')}</Button>
          </div>
        </DialogContent>
      </Dialog>
    )
}

export default ContactSupportModal
